import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loading from '../../components/Loading/Loading';
import { auth } from '../../lib/firebase';

const PublicRoutes = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // Don't redirect if user is in the middle of signing up or logging in
      const isSigningUp = sessionStorage.getItem('isSigningUp') === 'true';
      const isLoggingIn = sessionStorage.getItem('isLoggingIn') === 'true';

      if (isSigningUp || isLoggingIn) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // User is authenticated if they exist AND either:
      // 1. Email is verified (email/password users)
      // 2. Signed in with Google (OAuth providers have emailVerified = true by default)
      const authenticated =
        user &&
        (user.emailVerified ||
          user.providerData.some(
            (provider) => provider.providerId === 'google.com',
          ));
      setIsAuthenticated(authenticated);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  // Signed-in players have no business on login/signup, so send them to the game
  return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />;
};

export default PublicRoutes;